module.exports = __webpack_public_path__ + "e88c77b1b4edba1cdb688e789514ab93.pdf";